import React from 'react'

function SlideProductLoading() {
  return (
    <div>
    <div className='Loading_SlideProduct'>
    <div className='Slide_products slide'>
    <div className="Container">
        <div className="top_slide">
            <h2 className='skiles'></h2>
            <p className='skiles'></p>
    </div>



    <div className="Product_Loading">

        <div className="Product">
            <div className="img_product skiles"></div>
            <div className="content skiles"></div>
            <div className="content skiles"></div>
        </div>

        <div className="Product">
            <div className="img_product skiles"></div>
            <div className="content skiles"></div>
            <div className="content skiles"></div>
        </div>

        <div className="Product">
            <div className="img_product skiles"></div>
            <div className="content skiles"></div>
            <div className="content skiles"></div>
        </div>
        
        <div className="Product">
            <div className="img_product skiles"></div>
            <div className="content skiles"></div>
            <div className="content skiles"></div>
        </div>
    </div>
    </div>
   
    </div>
    </div>
    </div>
  )
}

export default SlideProductLoading